import { Box } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { ActivityDetailColumnAlign } from './activity-detail-column-layout';

type Props = {
  align: ActivityDetailColumnAlign;
  allowWrap?: boolean;
  children: ReactNode;
};

export function ActivityDetailTableCell({
  align,
  allowWrap = false,
  children,
}: Props) {
  return (
    <Box
      w="full"
      minW={0}
      display="flex"
      flexDirection="column"
      alignItems={
        align === 'right'
          ? 'flex-end'
          : align === 'center'
          ? 'center'
          : 'flex-start'
      }
      textAlign={align}
      overflow={allowWrap ? 'visible' : 'hidden'}
      sx={
        allowWrap
          ? {
              '& p, & span': {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'anywhere',
              },
            }
          : {
              '& > *': {
                maxW: '100%',
              },
              '& p, & span': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },
            }
      }
    >
      {children}
    </Box>
  );
}
